import { useQuery } from 'react-query';

import { getActivityCodesAliases as queryFn } from 'api/endPoints/getActivityCodesAliases';

export const useQueryGetActivityCodesAliases = ({ contractId }) => {
    return useQuery(['useQueryGetActivityCodesAliases', contractId], () => queryFn(contractId), {
        enabled: Boolean(contractId),
    });
};
